import React from 'react';
import { Card, Container, Row, Col } from 'react-bootstrap';
import Table from './Table'; // Assuming you have a Table component

import styles from './DashboardTableCard.module.scss'; // Import your CSS file for styling

type DashboardTableCardProps = {
    welcomeMessage?: string | null;
    tableData: {
        headings?: React.ReactNode[];
        data: React.ReactNode[][];
        footering?: React.ReactNode[][];
    }
};

const DashboardTableCard: React.FC<DashboardTableCardProps> = ({ welcomeMessage, tableData }) => {

    return (
        <Container className="my-4">
            <Row className="data-content align-items-center">
                <Col className={styles["center"]}>
                    <Card className={styles["boas-vindas"]}>
                        <Card.Body>
                            {welcomeMessage && <Card.Title className={styles.h5}>{welcomeMessage}</Card.Title>}
                            <Table
                                headings={tableData?.headings ?? []} // Example headings, adjust as needed
                                data={tableData?.data ?? []}
                                footering={tableData?.footering ?? []} // Example footering, adjust as needed
                            />
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default DashboardTableCard;
